import { Context, createStore, ExtendedModel, model } from '@weavix/mobx';
import { ProductPackageRecord } from '@weavix/mobx/src/models/product-package/product-package-record';

const base = createStore<ProductPackageRecord>('packages', ProductPackageRecord);
export const productPackagesContext = base.context as Context<ProductPackagesStore>;

/** Package definitions and account defaults synced for every account the user belongs to. */
@model('ProductPackagesStore')
export class ProductPackagesStore extends ExtendedModel(base.Store, {}) {
}
